export default __webpack_public_path__ + "static/media/ap.361b2ad9.png";